// 开卡参数混入 (支持动态金额字段)
export default {
    methods: {
        getOpenCardLocationParams(QueryOpenCardLocationData, amountKey = "sumFee") {
            const QueryData = QueryOpenCardLocationData;
            const isPayFinish = QueryData.sumFee > 0;
            return {
                applyEvent: "1", //业务类型
                belongCode: "360", //号码归属地
                uimId: QueryData.uimId, //卡号
                dealerId: QueryData.dealerId, //代理商编号
                cityCode: QueryData.cityCode, //受理人所在地市
                serviceId: QueryData.serviceId, //手机号
                resInstId: QueryData.resInstId, //号码的实例ID
                prodOfferId: QueryData.prodOfferId, //套餐ID
                ifCheckCard: QueryData.ifCheckCard, //是否添加小卡版
                serviceKind: QueryData.serviceKind, //运营商类型
                acceptPerson: QueryData.acceptPerson, //工号
                uimResInstId: QueryData.uimResInstId, //卡号的实例ID
                recordNumber: QueryData.recordNumber, //订单号
                dealerMainId: QueryData.dealerMainId, //顶级渠道
                [amountKey]: isPayFinish ? QueryData.sumFee : "", // 动态金额字段名
                rechargeFlag: QueryData.rechargeFlag, //充值标记 start进入支付 finish支付成功
                outTradeNo: isPayFinish ? QueryData.outTradeNo : "", //商户流水号
            }

        },
    }
}